import { carlineLinkService } from "./v1";
export function defineCarlineLinkService(options) {
    return {
        id: "audi-carline-link-service",
        dependencies: {
            externals: {
                axios: ">=0.21.1",
            },
            featureServices: {
                "s2:logger": "^1.0.0",
                "gfa:locale-service": "^1.0.0",
            },
        },
        create: ({ featureServices }) => {
            return {
                "1.0.0": () => {
                    return {
                        featureService: carlineLinkService(options ?? {}, featureServices),
                    };
                },
            };
        },
    };
}
//# sourceMappingURL=feature-service.js.map